import INVENTORY_API_BASE_URL from "../../config/api";
import React, { useState, useEffect } from "react";
import Axios from "axios";
import "./returnmis.css";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function Returnmis() {
  const [salesData, setSalesData] = useState([]);
  const [returnData, setReturnData] = useState([]);
  const [mergedData, setMergedData] = useState([]);
  const [distributors, setDistributors] = useState([]);
  const [selectedDistributor, setSelectedDistributor] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/getApproveDPO`).then(
      (response) => {
        setSalesData(response.data);
      }
    );

    Axios.get(`${INVENTORY_API_BASE_URL}/getManagereturn`).then(
      (response) => {
        setReturnData(response.data);

        const uniqueDistributors = [
          ...new Set(response.data.map((item) => item.Distributor)),
        ];
        setDistributors(uniqueDistributors);
      }
    );
  }, []);

  useEffect(() => {
    if (!salesData.length || !returnData.length) return;

    const dataMap = {};

    salesData.forEach((order) => {
      order.updatedQuantity.forEach((item) => {
        const key = `${order.distributorName}||${item.sku}||${item.title}`;

        if (!dataMap[key]) {
          dataMap[key] = {
            distributor: order.distributorName,
            sku: item.sku,
            title: item.title,
            medium: item.Medium,
            edition: item.edition,
            mrp: item.mrp,
            sellingPrice: item.PurchaseValue,
            soldQuantity: item.approvedquantity,
            salesValue: item.approvedOrderValue,

            grnNo: "",
            invoiceNo: "",
            date: "",
            discount: "",
            returnValue: "",
            hsnCode: "",
            returnQuantity: 0,
            goodQuantity: 0,
            badQuantity: 0,
          };
        } else {
          dataMap[key].soldQuantity += item.approvedquantity;
          dataMap[key].salesValue += item.approvedOrderValue;
        }
      });
    });

    returnData.forEach((order) => {
      order.Entries.forEach((entry) => {
        const key = `${order.Distributor}||${entry.SKU}||${entry.Title}`;

        if (!dataMap[key]) {
          dataMap[key] = {
            distributor: order.Distributor,
            sku: entry.SKU,
            title: entry.Title,
            medium: entry.Medium,
            edition: entry.Edition,
            mrp: entry.mrp,
            sellingPrice: "",
            soldQuantity: 0,
            salesValue: "",
            grnNo: order.OrderSeq,
            invoiceNo: order.Invoice_Number,
            date: order.Date,
            discount: entry.discount,
            returnValue: order.totalAmountValue,
            hsnCode: entry.HSNCode,
            returnQuantity: entry.Return_Quantity,
            goodQuantity: entry.Good_Quantity,
            badQuantity: entry.Bad_Quantity,
          };
        } else {
          dataMap[key].grnNo = order.OrderSeq;
          dataMap[key].invoiceNo = order.Invoice_Number;
          dataMap[key].date = order.Date;
          dataMap[key].discount = entry.discount;
          dataMap[key].returnValue = order.totalAmountValue;
          dataMap[key].hsnCode = entry.HSNCode;
          dataMap[key].returnQuantity += entry.Return_Quantity;
          dataMap[key].goodQuantity += entry.Good_Quantity;
          dataMap[key].badQuantity += entry.Bad_Quantity;
        }
      });
    });

    setMergedData(Object.values(dataMap));
  }, [salesData, returnData]);

  const filteredData = mergedData.filter((item) => {
    const distributorMatch = selectedDistributor
      ? item.distributor === selectedDistributor
      : true;

    const searchMatch = searchQuery
      ? item.sku.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.title.toLowerCase().includes(searchQuery.toLowerCase())
      : true;

    const dateMatch =
      startDate && endDate
        ? new Date(item.date) >= startDate && new Date(item.date) <= endDate
        : true;

    return distributorMatch && searchMatch && dateMatch;
  });

  const isFiltered = selectedDistributor || searchQuery;
  const paginatedData = isFiltered
    ? filteredData
    : filteredData.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
      );

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const handleNextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
  };

  const handlePrevPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  const exportToCSV = () => {
    const headers = [
      "Distributor",
      "SKU",
      "Title",
      "Medium",
      "Edition",
      "MRP",
      "Selling Price",
      "Sold Quantity",
      "Sales Value (Rs)",
      "GRN No",
      "Return Date",
      "Discount Value",
      "Return Quantity",
      "Credit Note Value",
      "Net Sales Value",
      "Net Sales Quantity",
      "Return %",
    ];

    const rows = filteredData.map((item) => [
      item.distributor,
      item.sku,
      item.title,
      item.medium,
      item.edition,
      item.mrp,
      item.sellingPrice,
      item.soldQuantity,
      item.salesValue,
      item.grnNo,
      item.date,
      item.discount,
      item.returnQuantity,
      item.returnQuantity && item.sellingPrice
        ? (item.returnQuantity * item.sellingPrice).toFixed(2)
        : 0,
      item.soldQuantity && item.sellingPrice
        ? (
            (item.soldQuantity - item.returnQuantity) *
            item.sellingPrice
          ).toFixed(2)
        : 0,
      item.soldQuantity - item.returnQuantity,
      item.soldQuantity
        ? ((item.returnQuantity / item.soldQuantity) * 100).toFixed(2) + "%"
        : "0%",
    ]);

    let csvContent =
      "data:text/csv;charset=utf-8," +
      [headers.join(","), ...rows.map((e) => e.join(","))].join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "return_mis.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="returnmis-container">
      <h2 style={{ textAlign: "center" }}>Return MIS</h2>
      <br />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "16px",
          marginBottom: "20px",
          flexWrap: "wrap",
        }}
      >
        <button
          onClick={() => navigate("/Viewdata")}
          style={{
            padding: "8px 16px",
            borderRadius: "6px",
            border: "none",
            backgroundColor: "#4A90E2",
            color: "#fff",
            fontSize: "14px",
            fontWeight: "600",
            cursor: "pointer",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            transition: "background-color 0.3s, box-shadow 0.3s",
          }}
          onMouseEnter={(e) => (e.target.style.backgroundColor = "#357ABD")}
          onMouseLeave={(e) => (e.target.style.backgroundColor = "#4A90E2")}
        >
          ⬅️ Back
        </button>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            marginLeft: "22rem",
          }}
        >
          <label
            style={{
              fontWeight: "600",
              fontSize: "14px",
              color: "#333",
              whiteSpace: "nowrap",
            }}
          >
            Select Date Range :
          </label>
          <DatePicker
            selected={startDate}
            onChange={(dates) => {
              const [start, end] = dates;
              setStartDate(start);
              setEndDate(end);
              setCurrentPage(1);
            }}
            startDate={startDate}
            endDate={endDate}
            selectsRange
            placeholderText="Select date range"
            popperPlacement="bottom-start"
          />
        </div>

        <button
          onClick={() => {
            setStartDate(null);
            setEndDate(null);
            setCurrentPage(1);
          }}
          style={{
            padding: "8px 16px",
            borderRadius: "6px",
            border: "none",
            backgroundColor: "#FF5C5C",
            color: "#fff",
            fontSize: "14px",
            fontWeight: "600",
            cursor: "pointer",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            transition: "background-color 0.3s, box-shadow 0.3s",
          }}
          onMouseEnter={(e) => (e.target.style.backgroundColor = "#e04e4e")}
          onMouseLeave={(e) => (e.target.style.backgroundColor = "#FF5C5C")}
        >
          Clear Date
        </button>
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: "20px",
          gap: "24px",
          width: "100%",
          flexWrap: "nowrap",
          marginTop: "1rem",
          justifyContent: "space-between",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", flex: "1" }}>
          <label
            style={{
              marginRight: "10px",
              whiteSpace: "nowrap",
              fontWeight: "600",
              fontSize: "14px",
              color: "#333",
              minWidth: "140px",
              textAlign: "right",
            }}
          >
            Select Distributor:
          </label>
          <select
            value={selectedDistributor}
            onChange={(e) => {
              setSelectedDistributor(e.target.value);
              setCurrentPage(1);
            }}
            style={{
              flex: "1",
              height: "38px",
              padding: "0 12px",
              borderRadius: "6px",
              border: "1px solid #ccc",
              fontSize: "14px",
              backgroundColor: "#fff",
              outline: "none",
              cursor: "pointer",
              boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
              transition: "border-color 0.3s, box-shadow 0.3s",
            }}
            onFocus={(e) => (e.target.style.borderColor = "#4A90E2")}
            onBlur={(e) => (e.target.style.borderColor = "#ccc")}
          >
            <option value="">-- All Distributors --</option>
            {distributors.map((dist, idx) => (
              <option key={idx} value={dist}>
                {dist}
              </option>
            ))}
          </select>
        </div>

        <div style={{ display: "flex", alignItems: "center", flex: "1" }}>
          <label
            style={{
              marginRight: "10px",
              whiteSpace: "nowrap",
              fontWeight: "600",
              fontSize: "14px",
              color: "#333",
              minWidth: "140px",
              textAlign: "right",
            }}
          >
            Search SKU or Title:
          </label>
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => {
              setSearchQuery(e.target.value);
              setCurrentPage(1);
            }}
            placeholder="Enter SKU or Title"
            style={{
              flex: "1",
              height: "38px",
              padding: "0 12px",
              borderRadius: "6px",
              border: "1px solid #ccc",
              fontSize: "14px",
              outline: "none",
              boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
              transition: "border-color 0.3s, box-shadow 0.3s",
            }}
            onFocus={(e) => (e.target.style.borderColor = "#4A90E2")}
            onBlur={(e) => (e.target.style.borderColor = "#ccc")}
          />
        </div>

        <button
          onClick={exportToCSV}
          style={{
            padding: "10px 20px",
            borderRadius: "6px",
            border: "none",
            backgroundColor: "#4A90E2",
            color: "#fff",
            fontSize: "14px",
            fontWeight: "600",
            cursor: "pointer",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            transition: "background-color 0.3s, box-shadow 0.3s",
          }}
          onMouseEnter={(e) => (e.target.style.backgroundColor = "#357ABD")}
          onMouseLeave={(e) => (e.target.style.backgroundColor = "#4A90E2")}
        >
          Export CSV
        </button>
      </div>

      <div className="returnmis-table-wrapper">
        <table>
          <thead>
            <tr>
              <th>Distributor</th>
              <th>SKU</th>
              <th>Title</th>
              <th>Medium</th>
              <th>Edition</th>
              <th>MRP</th>
              <th>Selling Price</th>
              <th>Sold Quantity</th>
              <th>Sales Value (Rs)</th>
              <th>GRN No</th>
              <th>Return Date</th>
              <th>Discount Value</th>
              <th>Return Quantity</th>
              <th>Credit Note Value</th>
              <th>Net Sales Value</th>
              <th>Net Sales Quantity</th>
              <th>Return %</th>
            </tr>
          </thead>
          <tbody>
            {paginatedData.map((item, idx) => (
              <tr key={idx}>
                <td>{item.distributor}</td>
                <td>{item.sku}</td>
                <td>{item.title}</td>
                <td>{item.medium}</td>
                <td>{item.edition}</td>
                <td>{item.mrp}</td>
                <td>{item.sellingPrice}</td>
                <td>{item.soldQuantity}</td>
                <td>{item.salesValue}</td>
                <td>{item.grnNo}</td>
                <td>{item.date}</td>
                <td>{item.discount}</td>
                <td>{item.returnQuantity}</td>
                <td>
                  {item.returnQuantity && item.sellingPrice
                    ? (item.returnQuantity * item.sellingPrice).toFixed(2)
                    : 0}
                </td>
                <td>
                  {item.soldQuantity && item.sellingPrice
                    ? (
                        (item.soldQuantity - item.returnQuantity) *
                        item.sellingPrice
                      ).toFixed(2)
                    : 0}
                </td>
                <td>{item.soldQuantity - item.returnQuantity}</td>
                <td>
                  {item.soldQuantity
                    ? ((item.returnQuantity / item.soldQuantity) * 100).toFixed(
                        2
                      ) + "%"
                    : "0%"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {!isFiltered && totalPages > 1 && (
        <div style={{ marginTop: "20px", textAlign: "center" }}>
          <button
            onClick={handlePrevPage}
            disabled={currentPage === 1}
            style={{
              marginRight: "10px",
              padding: "8px 16px",
              borderRadius: "4px",
              border: "1px solid #ccc",
              cursor: currentPage === 1 ? "not-allowed" : "pointer",
            }}
          >
            Previous
          </button>
          <span style={{ margin: "0 10px" }}>
            Page {currentPage} of {totalPages}
          </span>
          <button
            onClick={handleNextPage}
            disabled={currentPage === totalPages}
            style={{
              marginLeft: "10px",
              padding: "8px 16px",
              borderRadius: "4px",
              border: "1px solid #ccc",
              cursor: currentPage === totalPages ? "not-allowed" : "pointer",
            }}
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
}

export default Returnmis;
